import * as React from "react";
import { useProductState, useProductDispatch } from "context/AppContext";
import { Product } from "db";
import { calcPrice } from "components/configure/Configurator";

export default function Syncher() {
  const product = useProductState();
  const dispatch = useProductDispatch();
  React.useEffect(() => {
    let cart = document.getElementById("cart")?.textContent;
    if (cart) {
      try {
        let { codes } = JSON.parse(cart);
        dispatch({
          type: "setOptions",
          groupIndex: 0,
          accessoryIndex: 0,
          optionIndex: 0,
          b: true,
          codes: codes
        });
      } catch (err) {
        console.error(err);
      }
    }
  }, [dispatch]);

  React.useEffect(() => {
    let codes = activeCodes(product);
    let price = calcPrice(product);
    let el = document.getElementById("cart");
    if (el) {
      el.textContent = JSON.stringify({
        codes,
        price
      });
    }

    if (codes.includes("DCF01") || codes.includes("DCL01")) {
      dispatch({
        type: "setOptions",
        groupIndex: 0,
        accessoryIndex: 0,
        optionIndex: 0,
        b: true,
        codes: ["DCS01"]
      });
    }
  }, [product, dispatch]);

  return null;
}

function activeCodes(product: Product): string[] {
  let result: string[] = [];
  product.groups.forEach((g) => {
    g.accessories.forEach((a) => {
      a.options.forEach((o) => {
        if (o.selected) {
          result.push(o.code);
        }
      });
    });
  });
  return result;
}
